import {HttpService} from "./HttpService";

class UserService {

    get platformUserDetails() {
        return new Promise((resolve, reject) => {
            HttpService.create().get('/api/user/currentPlatformUser')	//todo: add this resource to api
                .then(result => resolve(result.data))
                .catch(err => reject(err));
        });
    }

}

const svc = new UserService();
export default svc;
